var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_163_91957",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_163_91957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0073 21.5999C10.686 21.5999 9.44206 21.3499 8.27539 20.8499C7.10872 20.3499 6.08789 19.6624 5.21289 18.7874C4.33789 17.9124 3.65039 16.8919 3.15039 15.726C2.65039 14.56 2.40039 13.3141 2.40039 11.9885C2.40039 10.6628 2.65039 9.42074 3.15039 8.2624C3.65039 7.10407 4.33789 6.0874 5.21289 5.2124C6.08789 4.3374 7.10837 3.6499 8.27434 3.1499C9.44032 2.6499 10.6862 2.3999 12.0118 2.3999C13.3375 2.3999 14.5796 2.6499 15.7379 3.1499C16.8962 3.6499 17.9129 4.3374 18.7879 5.2124C19.6629 6.0874 20.3504 7.10594 20.8504 8.268C21.3504 9.43009 21.6004 10.6718 21.6004 11.993C21.6004 13.3143 21.3504 14.5582 20.8504 15.7249C20.3504 16.8916 19.6629 17.9124 18.7879 18.7874C17.9129 19.6624 16.8944 20.3499 15.7323 20.8499C14.5702 21.3499 13.3285 21.5999 12.0073 21.5999ZM10.8004 19.6999V17.9999C10.4671 17.9999 10.1837 17.8824 9.95039 17.6474C9.71706 17.4124 9.60039 17.1299 9.60039 16.7999V15.5999L4.37539 10.3749C4.30872 10.6916 4.26289 10.9832 4.23789 11.2499C4.21289 11.5166 4.20039 11.7666 4.20039 11.9999C4.20039 13.9166 4.82122 15.6082 6.06289 17.0749C7.30456 18.5416 8.88372 19.4166 10.8004 19.6999ZM18.0004 16.9749C18.3004 16.6249 18.5629 16.2582 18.7879 15.8749C19.0129 15.4916 19.1992 15.087 19.3469 14.6611C19.4945 14.2352 19.607 13.7977 19.6844 13.3486C19.7617 12.8995 19.8004 12.4499 19.8004 11.9999C19.8004 10.4231 19.3671 8.98307 18.5004 7.6798C17.6337 6.37654 16.4671 5.41657 15.0004 4.7999V5.3999C15.0004 5.8949 14.8241 6.31865 14.4716 6.67115C14.1191 7.02365 13.6954 7.1999 13.2004 7.1999H10.8004V8.3999C10.8004 8.7399 10.6854 9.0249 10.4554 9.2549C10.2254 9.4849 9.94039 9.5999 9.60039 9.5999H8.40039V11.9999H14.4004C14.7404 11.9999 15.0254 12.1149 15.2554 12.3449C15.4854 12.5749 15.6004 12.8599 15.6004 13.1999V15.5999H16.6254C17.0087 15.5999 17.3337 15.7332 17.6004 15.9999C17.8671 16.2666 18.0004 16.5916 18.0004 16.9749Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.438cd7cf215ee9ecda3bd3c53e130f59.svg";
export { ForwardRef as ReactComponent };